import { Controller } from '@hotwired/stimulus'

const isCapacitorApp = () =>
  typeof navigator !== 'undefined' && navigator.userAgent.includes('VesselindexApp')

export default class extends Controller {
  connect() {
    if (!isCapacitorApp()) return
    document.addEventListener('click', this.handleClick, true)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClick, true)
  }

  handleClick = async (event) => {
    const link = event.target.closest('a[target="_blank"]')
    if (!link || !link.href) return

    const Capacitor = window.Capacitor
    const Browser = Capacitor && Capacitor.Plugins && Capacitor.Plugins.Browser
    if (!Browser) return

    event.preventDefault()
    try {
      await Browser.open({ url: link.href, presentationStyle: 'popover' })
    } catch (err) {
      console.warn('Capacitor Browser.open failed; falling back to default link', err)
      window.location.href = link.href
    }
  }
}
